const ExecutorTypes = {
  DEFAULT: "DEFAULT"
};

module.exports = ExecutorTypes;



// WEBPACK FOOTER //
// ./src/js/constants/ExecutorTypes.js